module.exports = {
  language: {
    name: 'English'
  },
  header: {
    lang: '中文版',
    home: 'HOME',
    product: 'PRODUCT',
    video: 'VIDEO',
    news: 'NEWS',
    about: 'ABOUT',
    search: 'search',
    langageimg: "cn.png",
  },
  footer: {
    lang: '中文版',
    home: 'HOME',
    product: 'PRODUCT',
    video: 'VIDEO',
    news: 'NEWS',
    about: 'ABOUT',
    concact: 'Address：Junction of Cheng Jiang Road and an Hua road, Cheng Hua street, Cheng Hai district, Shantou, Guangdong Province　|　Contact：Export：+86-754-85897999 Domestic： 0754-85688999',
    power: 'Copyright HAItAITOYS 2022-2030 All Right Reserved ',
    address: 'Record <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18053044号</a><img data-v-40ab164b="" src="https://api.seasuntoys.com/ba.png"><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44051502000423" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44051502000423号</p></a>',
  }
}



// WEBPACK FOOTER //
// ./src/components/language/en.js